import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-criteria-three',
  templateUrl: './criteria-three.component.html',
  styleUrls: ['./criteria-three.component.scss']
})
export class CriteriaThreeComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu = true;
  // showHeading = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 4 ){
      this.showSideMenu=true;
      this.fullWidth=false;
      // this.showHeading = true;
    }
    // else if(url.length === 5){
    //   this.showSideMenu=true;
    //   this.fullWidth=true;
    //   // this.showHeading = false;
    // }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
